// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"d167ce3f","194":"84ff79c1","258":"7deace18","315":"4813ddce","548":"ffdeca59","559":"8746c71f","623":"68086d5d","773":"72028dc2","884":"d679ecc1"}[chunkId] + ".chunk.js";
};